export const ID = 'id';
export const KEY = 'key';
export const CREATIVES = 'creatives';
export const REQUESTED_BY = 'requestedBy';
export const JIRA_TASK = 'jiraTask';
export const DESIGNER = 'author';
export const IS_THUMBNAIL_GENERATING = 'isThumbnailGenerating';
export const AI_GENERATED = 'isAICreated';

export const CREATIVE_TYPE = 'creativeTypeId';
export const COLOR = 'color';
export const ENHANCERS = 'enhancers';
export const NETWORKS = 'networks';
export const INTERNAL_TAGS = 'internalTags';
export const AI_TAGS = 'aiTags';
export const INHERIT_TAGS = 'inheritTags';
export const CHANNELS = 'channels';
export const POSTFIX = 'postfix';
export const OS = 'os';
export const LANGUAGE = 'language';
export const DESCRIPTION = 'description';
export const APPLICATION = 'application';
export const FILE = 'file';
export const FILE_GUID = 'fileGuid';
export const CONCEPT = 'concept';
export const YOUTUBE_LINK = 'youtubeLink';
export const EXCLUSIVE_FOR_AFFILIATES = 'exclusiveForAffiliates';
export const PRODUCTION_TYPE = 'productionType';

export const COMMENTS = 'comments';
export const REVIEWS = 'reviews';

export const UPDATED_BY = 'updatedBy';
export const UPDATED_DATE = 'updatedDate';
export const CREATED_BY = 'createdBy';
export const CREATED_DATE = 'createdDate';

export const NAME = 'name';
export const SHORT_NAME = 'shortName';
export const IS_ORIGINAL = 'isOriginal';

export const START_DATE = 'startDate';
export const EXPIRATION_DATE = 'expirationDate';
export const UNARCHIVE_DATE = 'unarchiveDate';
export const STATUS_UPDATE_DATE = 'statusUpdateDate';
export const HAS_STATS = 'hasStats';
export const USED_IN_AFFILIATES = 'affiliates';
export const COMMENTS_COUNT = 'commentsCount';
export const RATING = 'rating';
export const IS_SHARED = 'isShared';
export const SHARED_WITH = 'sharedWith';
export const BUSINESS_PARTNERS = 'businessPartners';
export const STATUS_ID = 'statusId';
export const OUTSOURCE_STUDIO = 'outsourceStudio';
export const MOVED_FROM_CONCEPT = 'movedFromConcept';
export const ACTIONS = 'actions';
export const STATE_SCHEDULES = 'stateSchedules';
export const TESTED = 'tested';
